import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { open: { type: Boolean, default: false } }

  declare openValue: boolean

  connect() {
    if (this.openValue) {
      this.open()
    } else {
      this.hide()
    }
  }

  close(event?: Event) {
    if (event) event.preventDefault()
    this.hide()
  }

  private open() { this.element.classList.add("is-open") }
  private hide() { this.element.classList.remove("is-open") }
}


